import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import "firebase/compat/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyCbY15kOpdfE8F-AdGs_2rU_wvRX0oKg4s",
  authDomain: "fir-8b42b.firebaseapp.com",
  projectId: "fir-8b42b",
  storageBucket: "fir-8b42b.appspot.com",
  messagingSenderId: "634894253087",
  appId: "1:634894253087:web:cd7c3c02cf62b51fb3a92a",
  measurementId: "G-TS3VKR36GV"
};
const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };